import React from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { currentLanguage, t } from "@/i18n";

const formatDate = (iso) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(currentLanguage() === "en" ? "en-GB" : "fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export const ArticleCard = ({ article }) => (
  <article className="surface overflow-hidden rounded-xl" data-testid={`article-card-${article.slug}`}>
    <Link to={`/blog/${article.slug}`} className="block">
      {article.cover_url ? (
        <div className="relative">
          <img
            src={article.cover_url}
            alt=""
            loading="lazy"
            className="h-44 w-full object-cover"
          />
          {article.video?.embed_url ? (
            <span
              className="absolute bottom-3 left-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium"
              style={{ backgroundColor: "rgba(31,35,32,0.82)", color: "var(--paper)" }}
            >
              <Play className="h-3 w-3" /> {t("site.watch")}
            </span>
          ) : null}
        </div>
      ) : null}

      <div className="p-5">
        <p className="font-num text-[11px] uppercase tracking-[0.1em] text-[color:var(--muted-ink)]">
          {[formatDate(article.published_at), `${article.reading_minutes} ${t("site.minRead")}`]
            .filter(Boolean)
            .join(" · ")}
        </p>
        <h3 className="mt-2 text-[22px] font-semibold leading-tight">{article.title}</h3>
        {article.excerpt ? (
          <p className="mt-2 text-[13.5px] leading-relaxed text-[color:var(--ink-soft)]">
            {article.excerpt}
          </p>
        ) : null}
        {article.tags?.length ? (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {article.tags.slice(0, 4).map((tag) => (
              <span
                key={tag}
                className="rounded-full px-2 py-0.5 text-[11px]"
                style={{ backgroundColor: "var(--paper-2)", color: "var(--ink-soft)" }}
              >
                {tag}
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </Link>
  </article>
);

export default ArticleCard;
